export const MCESupportKind = {
  PRIOR: 'PRIOR',
  POST_PROJECT_APPROVAL: 'POST_PROJECT_APPROVAL',
  values: () => {
    return ['PRIOR', 'POST_PROJECT_APPROVAL'];
  },
};
